import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../shared/Button';

const WarnMessage = ({ open, onClose, onSave, header, message, question, name, translate }) => (
  <Dialog fullWidth open={open} onClose={onClose} disableBackdropClick className="WarnMessage">
    <DialogTitle className="WarnMessage-header" disableTypography>
      <DialogActions>
        <button type="button" className="WarnMessage-closeButton" onClick={onClose}>
          &times;
        </button>
      </DialogActions>
      {translate(header)}
    </DialogTitle>
    <DialogContent className="WarnMessage-content">
      <DialogContentText className="WarnMessage-message">
        {translate(message, { name })}
      </DialogContentText>
      <DialogContentText className="WarnMessage-message">{translate(question)}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button handleClick={onClose}>{translate('reservation.cancel')}</Button>
      <Button handleClick={onSave} active>
        {translate('reservation.yes')}
      </Button>
    </DialogActions>
  </Dialog>
);

WarnMessage.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  header: PropTypes.string,
  message: PropTypes.string,
  question: PropTypes.string,
  name: PropTypes.string,
  translate: PropTypes.func,
};

WarnMessage.defaultProps = {
  open: false,
  onClose: () => {},
  onSave: () => {},
  header: '',
  message: '',
  question: '',
  name: '',
  translate: () => {},
};

export default WarnMessage;
